import { render, staticRenderFns } from "./TemplateEditForm.vue?vue&type=template&id=11c4e668&scoped=true&"
import script from "./TemplateEditForm.vue?vue&type=script&lang=ts&"
export * from "./TemplateEditForm.vue?vue&type=script&lang=ts&"
import style0 from "./TemplateEditForm.vue?vue&type=style&index=0&id=11c4e668&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c4e668",
  null
  
)

export default component.exports